import { CompraPendienteMaster } from '../services/comprasSeguimientoService';
import { RemitoCompra } from '../services/remitoCompraService';

export interface RemitoCompraEstadoFacturacion {
  puedeFacturar: boolean;
  facturadoCompleto: boolean;
  facturadoParcial: boolean;
  ultimaFactura?: number;
}

export function pendienteFacturarLineaRemito(
  remito: RemitoCompra,
  detalle: NonNullable<RemitoCompra['detalles']>[number],
  pendientesPorMaster: Map<string, CompraPendienteMaster>
): number {
  const masterForm =
    detalle.nroFormularioMaster && detalle.nroFormularioMaster > 0
      ? detalle.nroFormularioMaster
      : remito.nroFormulario;
  const masterItem =
    detalle.nroItemMaster && detalle.nroItemMaster > 0 ? detalle.nroItemMaster : detalle.nroItem;
  const pend = pendientesPorMaster.get(`${masterForm}-${masterItem}`);
  return pend ? Number(pend.pendienteFacturar) || 0 : Number(detalle.cantidad) || 0;
}

export function calcularEstadoFacturacionRemito(
  remito: RemitoCompra,
  pendientesPorMaster: Map<string, CompraPendienteMaster>
): RemitoCompraEstadoFacturacion {
  const detalles = remito.detalles ?? [];
  const ultimaFactura =
    remito.nroFormularioFactura && remito.nroFormularioFactura > 0
      ? remito.nroFormularioFactura
      : undefined;

  let tienePendiente = false;
  for (const d of detalles) {
    if (pendienteFacturarLineaRemito(remito, d, pendientesPorMaster) > 0) {
      tienePendiente = true;
      break;
    }
  }

  if (detalles.length === 0) {
    const sinVinculoFactura = !ultimaFactura;
    return {
      puedeFacturar: sinVinculoFactura,
      facturadoCompleto: !sinVinculoFactura,
      facturadoParcial: false,
      ultimaFactura,
    };
  }

  return {
    puedeFacturar: tienePendiente,
    facturadoCompleto: !tienePendiente,
    facturadoParcial: !!ultimaFactura && tienePendiente,
    ultimaFactura,
  };
}

export async function buildPendientesPorProveedor(
  proveedores: number[],
  fetchPendientes: (nroProveedor: number) => Promise<CompraPendienteMaster[]>
): Promise<Map<number, Map<string, CompraPendienteMaster>>> {
  const unicos = Array.from(new Set(proveedores.filter((p) => p > 0)));
  const entries = await Promise.all(
    unicos.map(async (nroProveedor) => {
      try {
        const pendientes = await fetchPendientes(nroProveedor);
        const map = new Map(
          (pendientes || []).map((p) => [`${p.nroFormularioMaster}-${p.nroItemMaster}`, p] as const)
        );
        return [nroProveedor, map] as const;
      } catch {
        return [nroProveedor, new Map<string, CompraPendienteMaster>()] as const;
      }
    })
  );
  return new Map(entries);
}
